import { shallowMount } from "@vue/test-utils";
import Paso1 from "@/views/Paso1";

describe("Paso1 component", () => {
  let wrapper;
  let config;
  let getters;

  beforeEach(() => {
    config = {
      pasos: {
        paso1: {
          path: "/",
          component: "views/Paso1",
          header: "Datos de contacto",
          paso: 1,
          pasoSiguiente: "paso2",
          titulo: "Completá el formulario",
          subtitulo: "Ingresá tus datos, luego solicitá el cambio de banco.",
          subtitulo2:
            "Comenzá a acreditar tu jubilación ANSES en BBVA y te regalamos otra de $160.000"
        }
      }
    };

    getters = {
      getPaso1: () => ({
        nombre: "Lara",
        apellido: "Croft",
        email: "lara@gmail.com",
        celular: {
          area: "011",
          numero: "12313212"
        },
        documento: {
          tipo: "DNI",
          numero: "35999888"
        }
      })
    };

    wrapper = shallowMount(Paso1, {
      mocks: {
        $store: {
          dispatch: jest.fn(),
          commit: jest.fn(),
          getters
        },
        config
      }
    });
  });

  it("Renders del component Paso1", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
